import { EntityBase } from './EntityBase';
import { GeoPosition } from './GeoPosition';

export enum GeofenceType {
  radial = 0,
  polygon = 1,
}

export enum GeofenceLevel {
  station = 0,
  facility = 1,
}

export interface Geofence extends EntityBase {
  type: GeofenceType;
  typeDescr?: string;
  level: GeofenceLevel;
  levelDesc?: string;
  name: string;
  radius?: number;
  coordinates?: Array<[number, number]>;
  location?: GeoPosition;
  stationId?: string;
  stationIataCode?: string;
  facilityId?: string;
  facilityName?: string;
  showMarker?: boolean; //marker by geofence
}

// eslint-disable-next-line
export interface GeofenceResponse extends Geofence {}
